"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.StyledSoloIcon = exports.StyledButton = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _templateObject, _templateObject2, _templateObject3;
var marginLeft = 2;
var Wrapper = exports.Wrapper = _styledComponents["default"].span(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  left: ", "%;\n  width: calc(100% - ", "%);\n\n  z-index: 21;\n  position: absolute;\n  top: 3%;\n"])), marginLeft, marginLeft);
var StyledButton = exports.StyledButton = _styledComponents["default"].button(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 60px;\n  height: 60px;\n  border-radius: 3px;\n  border: 1px solid white;\n  box-sizing: border-box;\n  cursor: pointer;\n  background: ", ";\n"])), function (_ref) {
  var isActive = _ref.isActive;
  return isActive ? '#ffffff' : 'transparent';
});
var StyledSoloIcon = exports.StyledSoloIcon = (0, _styledComponents["default"])(_reactFontawesome.FontAwesomeIcon)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  font-size: 32px;\n  color: ", ";\n"])), function (_ref2) {
  var isActive = _ref2.isActive;
  return !isActive && '#ffffff';
});